import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Stack from 'react-bootstrap/Stack';
import { useChargeAttemptStatisticsQuery } from '../../queries/payment.query';
import ChargeActionsPanel from './ChargeActionsPanel';
import ChargeAttemptsChart from './ChargeAttemptsChart';
import ChargeAttemptsList from './ChargeAttemptsList';
import FailedInvoicesSection from './FailedInvoicesSection';
import PaymentStatisticsCards from './PaymentStatisticsCards';
import TimePeriodSelector from './TimePeriodSelector';
import TotalAmountChart from './TotalAmountChart';

function PaymentProcessingPage() {
  const [monthsBack, setMonthsBack] = useState(2);

  const { data: statistics, isLoading: statsLoading } = useChargeAttemptStatisticsQuery({
    monthsBack
  });

  return (
    <Container fluid className="py-4">
      <Stack direction="horizontal" className="justify-content-between align-items-center mb-4">
        <h2 className="mb-0">Payment Processing</h2>
        <Stack direction="horizontal" gap={2}>
          <span className="text-muted">Time Period:</span>
          <TimePeriodSelector monthsBack={monthsBack} onChange={setMonthsBack} />
        </Stack>
      </Stack>

      <ChargeActionsPanel />

      <PaymentStatisticsCards statistics={statistics} isLoading={statsLoading} />

      <Row className="g-4 mb-4">
        <Col xs={12} lg={6}>
          <ChargeAttemptsChart dataPoints={statistics?.dataPoints} isLoading={statsLoading} />
        </Col>
        <Col xs={12} lg={6}>
          <TotalAmountChart dataPoints={statistics?.dataPoints} isLoading={statsLoading} />
        </Col>
      </Row>

      <ChargeAttemptsList />

      <FailedInvoicesSection />
    </Container>
  );
}

export default PaymentProcessingPage;
